import ListMerchantItem from './ListMerchantItem';
import { type Merchant } from '../../../common/types';

interface IProps {
  items: Merchant[];
  filter?: { pending: boolean };
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  toggleApproveModal: () => any;
  handleEditingItem: (item: Merchant) => any;
  handleDeletingItem: (item: Merchant) => any;
  handleApprovingItem: (item: Merchant) => any;
}

const ListMerchants: React.FC<IProps> = ({
  items: merchants,
  toggleEditModal,
  toggleDeleteModal,
  toggleApproveModal,
  handleEditingItem,
  handleDeletingItem,
  handleApprovingItem
}) => {
  return (
    <>
      <div className="w-full p-2 my-2 overflow-auto rounded-md">
        <table className="w-full border-b-2 border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 pl-8 text-sm font-semibold text-left tracking-wide">Fullname</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Identifier</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Email</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Phone</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Status</th>
              <th className="w-12 p-2 pr-8 text-sm font-semibold tracking-wide">Actions</th>
            </tr>
          </thead>
          <tbody className="">
            {merchants.map((merchant) => {
              return (
                <ListMerchantItem
                  key={merchant.id}
                  toggleEditModal={toggleEditModal}
                  toggleDeleteModal={toggleDeleteModal}
                  toggleApproveModal={toggleApproveModal}
                  item={merchant}
                  handleEditingItem={handleEditingItem}
                  handleDeletingItem={handleDeletingItem}
                  handleApprovingItem={handleApprovingItem}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListMerchants;
